import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'

import { ChatMessageModel, ChatModel } from '@shared/models/messenger/messenger.model'

@Injectable({
  providedIn: 'root',
})
export class MessengerService {
  isShowList = new BehaviorSubject<boolean>(true)
  isShowDetail = new BehaviorSubject<boolean>(true)

  private isLoading = new BehaviorSubject<boolean>(false)
  readonly isLoading$ = this.isLoading.asObservable()

  private selectedChatId = new BehaviorSubject<number>(null)
  readonly selectedChatId$ = this.selectedChatId.asObservable()

  private unreadCount = new BehaviorSubject<number>(null)
  readonly unreadCount$ = this.unreadCount.asObservable()

  private chatList = new BehaviorSubject<ChatModel[]>([])
  readonly chatList$ = this.chatList.asObservable()

  private chatToolbarList = new BehaviorSubject<ChatModel[]>([])
  readonly chatToolbarList$ = this.chatToolbarList.asObservable()

  private selectedChat = new BehaviorSubject<ChatModel>(null)
  readonly selectedChat$ = this.selectedChat.asObservable()

  private chatMessageList = new BehaviorSubject<ChatMessageModel[]>([])
  readonly chatMessageList$ = this.chatMessageList.asObservable()

  private messageUpdate = new Subject<Pick<ChatMessageModel, 'id' | 'message'>>()
  readonly messageUpdate$ = this.messageUpdate.asObservable()

  private scrollToBottom = new BehaviorSubject<number>(0)
  readonly scrollToBottom$ = this.scrollToBottom.asObservable()

  setChatList(chatList: ChatModel[]): void {
    this.chatList.next(chatList)
  }

  setChatToolbarList(chatToolbarList: ChatModel[]): void {
    this.chatToolbarList.next(chatToolbarList)
  }

  setSelectedChat(selectedChat: ChatModel): void {
    this.selectedChat.next(selectedChat)
  }

  setChatMessageList(chatMessageList: ChatMessageModel[]): void {
    this.chatMessageList.next(chatMessageList)
  }

  setLoading(loading: boolean): void {
    this.isLoading.next(loading)
  }

  setSelectedChatId(selectedChatId: number): void {
    this.selectedChatId.next(selectedChatId)
  }

  setUnreadCount(unreadCount?: number, isUp?: boolean): void {
    this.unreadCount.next(unreadCount > -1 ? unreadCount : this.unreadCount.getValue() + (isUp ? 1 : -1) || 0)
  }

  setChatMessage(message: Pick<ChatMessageModel, 'id' | 'message'>): void {
    this.messageUpdate.next(message)
  }

  triggerScrollToBottom(): void {
    this.scrollToBottom.next(this.scrollToBottom.getValue() + 1)
  }
}
